module.exports = __webpack_public_path__ + "assets/104057999a3c15deeebd3f4d689119cb.team_member.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/src/styles/images/team_member.png
 ** module id = 122
 ** module chunks = 1
 **/